import React from 'react';

const Exclamation = ({ size, color, style, className }) => (
  <svg
    className={className}
    style={style}
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM5.25009 6.00009C5.25009 5.58588 5.58588 5.25009 6.00009 5.25009C6.41431 5.25009 6.75009 5.58588 6.75009 6.00009V9.00009C6.75009 9.41431 6.41431 9.75009 6.00009 9.75009C5.58588 9.75009 5.25009 9.41431 5.25009 9.00009V6.00009ZM6.00009 2.99995C5.58588 2.99995 5.25009 3.33574 5.25009 3.74995C5.25009 4.16417 5.58588 4.49995 6.00009 4.49995C6.41431 4.49995 6.75009 4.16417 6.75009 3.74995C6.75009 3.33574 6.41431 2.99995 6.00009 2.99995Z"
      fill={color}
    />
  </svg>
);

Exclamation.defaultProps = {
  size: '12',
  color: '#333333',
  className: '',
  style: {},
};

export default Exclamation;



// WEBPACK FOOTER //
// ./src/components/Icons/Exclamation/index.js